import React from 'react';
import { genClassName } from '../../../utils/helpers';

import './styles.css';

type Props = {
	label: string;
	text?: string;
	className?: string;
};

/**
 *
 * @typedef {Object} Props
 * @prop {String} label
 * @prop {String} [text]
 * @prop {String} [className]
 *
 * @augments {Component<Props>}
 */
const Badge: React.FC<Props> = ({ label, text, className }: Props) => {

	return (
		<span className={genClassName('Badge', className ? className : '')}>
			<span className='Badge-label'>{label}</span>
			{text && <span className='Badge-text'>{text}</span>}
		</span>
	);

};

export default Badge;
